// src/components/ProtectedRoute/Admin/Consoles/Pages/CountriesConsole.jsx
import React from "react";
import ConsolePageFrame from "../Framework/ConsolePageFrame";
import countriesPlugin from "../Plugins/countries.plugin";
import DialogCountryEditor from "../../Dialogs/DialogCountryEditor";

export default function CountriesConsole() {
  return (
    <ConsolePageFrame
      title="Countries"
      plugin={countriesPlugin}
      searchPlaceholder="Search name / ISO"
      columnsBuilder={() => countriesPlugin.columns()}
      renderAddDialog={({ onClose }) => <DialogCountryEditor open onClose={onClose} />}
      renderEditDialog={({ row, onClose }) => <DialogCountryEditor open country={row} onClose={onClose} />}
      toastMessages={{ create: "Country saved", update: "Country updated" }}
      initialPageSize={50}
      getRowId={(row) => row.id}
    />
  );
}
